import { render, staticRenderFns } from "./ReimbursementsTable.vue?vue&type=template&id=6c8db8ab&scoped=true"
import script from "./ReimbursementsTable.vue?vue&type=script&lang=js"
export * from "./ReimbursementsTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6c8db8ab&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8db8ab",
  null
  
)

export default component.exports